import { defaultTo } from 'ramda';
import { IWriteOffInfo } from '../../../redux/reducers';
import { IWriteOffInfoSchema } from '../../../repositories/monolith-python/entities/WriteOffInfoSchema';

export function mapWriteOffInfo(writeOffInfo?: IWriteOffInfoSchema | null): IWriteOffInfo {
  const { amount, period } = writeOffInfo || {};

  return {
    amount: defaultTo(0, amount),
    period: defaultTo('', period),
  };
}
